export const DAYS = {
    'en-US': ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    'he-IL': ["יום א'", "יום ב'", "יום ג'", "יום ד'", "יום ה'", "'יום ו'", "יום ש'"]
};
export const MONTHS = {
    'en-US': ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    'he-IL': ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
};

export const DEFAULT_PRESETS = ['1.5', '1.8', '2.0'];
export const DEFAULT_DOSE = '1.5';
export const MINIMUM_DOSE = 0.1;
export const MAXIMUM_DOSE = 5.0;
export const DOSE_STEP = 0.1;

export const PRESETS_STORAGE_KEY = 'asinu-presets';
export const DOSES_STORAGE_KEY = 'asinu-doses';
export const LANGUAGE_STORAGE_KEY = 'asinu-language';
export const DIR_STORAGE_KEY = 'asinu-dir';

export const SUPPORTED_LANGUAGES = {
    'en-US': { label: 'En' }
};
export const DEFAULT_LANGUAGE = 'en-US';
